import styled from "styled-components";

export const Container = styled.div`
    height: 75vh;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;